import React, { useEffect, useState } from 'react';
import cx from '../../utils/cx';
import Dialog, { IDialogProps } from './Dialog';
export interface IDialogTriggerProps {
    className?: string;
    trigger: React.ReactNode;
    title?: React.ReactNode;
    open: boolean;
    onClick: () => void;
    onClose: () => void;
    fullScreen?: boolean;
    maxWidth?: IDialogProps['maxWidth'];
    onSubmit?: (ev: React.FormEvent) => void;
    actions?: Array<React.ReactNode>;
    disableEnforceFocus?: boolean;
    disablePortal?: boolean;
}

const DialogTrigger: React.FC<React.PropsWithChildren<IDialogTriggerProps>> = ({ onClose, onClick, open, actions, trigger, children, title, fullScreen, maxWidth, onSubmit, disablePortal, className }) => {
    const isOpen = open == true;
    // const [isOpen, setIsOpen] = useState(false);

    // const handleClick = () => {
    //     setIsOpen(true);
    // };

    // const handleClose = () => {
    //     setIsOpen(false);
    // };

    if (typeof trigger !== 'object' || (trigger as React.ReactElement).type === React.Fragment) {
        trigger = <div>{trigger}</div>;
    }

    return (
        <>
            {React.cloneElement(trigger as React.ReactElement, { onClick })}
            {/* <div onClick={onClick}>{trigger}</div> */}
            <Dialog
                open={isOpen}
                onClose={onClose}
                title={title}
                fullScreen={fullScreen}
                onSubmit={onSubmit}
                actions={actions}
                className={cx('App__app___dnz', className)}
                disableEnforceFocus={true}
                disablePortal={disablePortal}
                maxWidth={maxWidth}
            >
                {children}
            </Dialog>
        </>
    );
};

export default DialogTrigger;
